import React from 'react';
import authRoutes from 'src/modules/auth/config/routes';
import appRoutes from 'src/modules/app/config/routes';
import onBoardingRoutes from 'src/modules/onBoarding/config/routes';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotAccessible from 'src/components/App/NotAccessible';
import { isSanginiRestrictedUser } from 'src/utils/sanginiUtils';
import { getUserFromToken } from 'src/DecodeToken';
import storage from 'src/utils/storageUtils';

const routes = [...onBoardingRoutes, ...authRoutes, ...appRoutes];

function AppRouter() {
  const permissions = useSelector((state) => state.auth?.permissions);
  const user = useSelector((state) => state.auth?.user);
  const currentClinicId = useSelector((state) => state.app?.clinics?.clinicId);
  const isSangini = isSanginiRestrictedUser(user);
  const doctorId = user?.id || user?._id || getUserFromToken();
  const clinicId = currentClinicId || storage.get('CLINIC_ID');

  return (
    <>
      <Routes>
        {routes.map(({ title, component: Component, url, exact, permission }) => {
          let element;
          if (isSangini) {
            const isAllowedForSangini =
              url.includes('/appointment') ||
              url.includes('/viewPrescription') ||
              url.startsWith('/auth') ||
              url.startsWith('/public');

            if (isAllowedForSangini) {
              element = <Component />;
            } else {
              element = <NotAccessible />;
            }
          } else {
            if (permission && permissions && permissions[permission] === 'no') {
              element = <NotAccessible />;
            } else {
              element = <Component />;
            }
          }

          return (
            <Route
              exact
              key={url}
              path={url}
              element={element}
            />
          );
        })}
      </Routes>
    </>
  );
}

export default AppRouter;

